import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export function AdminOnlyRoute({ children }) {
  const { user } = useAuth();

  if (user?.role === 'admin') {
    return children;
  }

  if (user?.role === 'partner_admin') {
    return <Navigate to="/partner-admin" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}

export function PartnerAdminOnlyRoute({ children }) {
  const { user } = useAuth();

  if (user?.role === 'partner_admin') {
    return children;
  }

  if (user?.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
